// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"366":"08cc0434","5754":"0083fb7c"}[chunkId] + ".chunk.css";
};